import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const HostnameChangeReload = () => {
	const hostnameChangeNeeded = useSelector(state => state.brand.hostnameChangeNeeded);

	useEffect(() => {
		if (hostnameChangeNeeded) {
			setTimeout(() => window.location.reload(), 500);
		}
	}, [hostnameChangeNeeded]);

	return null;
};

export default HostnameChangeReload;
